import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialInstitutionLaboratoryFinanceState: Dtos.TrialInstitutionLaboratoryFinance & IRegistrationFormState = {
    id: null,
    trialInstitutionLaboratoryId: null,
    trialInstitutionLaboratory: null,
    overrideFundingEmail: null,
    fundingEmail: null,
    bsbSwift: null,
    accountNumber: null,
    siteCostCentre: null,
    requireInvoiceFromSite: null,
    overridePaymentDetails: null,
    abn: null,
    taxInvoiceName: null,
    quickbooksTaxCodeId: null,
    quickbooksTaxCode: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialInstitutionLaboratoryFinanceReduxFormState {
    id: IFieldState<number>,
    trialInstitutionLaboratoryId: IFieldState<number>,
    trialInstitutionLaboratory: IFieldState<Dtos.TrialInstitutionLaboratory>,
    quickbooksTaxCodeId: IFieldState<number>,
    overrideFundingEmail: IFieldState<boolean>,
    fundingEmail: IFieldState<string>,
    bsbSwift: IFieldState<string>,
    accountNumber: IFieldState<string>,
    siteCostCentre: IFieldState<string>,
    requireInvoiceFromSite: IFieldState<boolean>,
    overridePaymentDetails: IFieldState<boolean>,
    abn: IFieldState<string>,
    taxInvoiceName: IFieldState<string>,
    quickbooksTaxCode: IFieldState<Dtos.QuickbooksTaxCode>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
